/**
 * The live Verizon Home Device Protect offer SKU — `ProductSku.VerizonHomeDeviceProtectAccountLevel`
 * ('3002') in ASP/product-config (partner `verizon`; the static fios `VZN_VHDP` is a different SKU).
 *
 * VHDP is the Long Form AI pilot offer: the narrative container only replaces the offer checklist
 * when this product is the selected offer. The enum itself lives in the sales-domain repo and isn't
 * importable here, so the SKU is pinned as a literal.
 */
export const VHDP_PRODUCT_SKU = "3002";

/**
 * V0 (false, shipping) loads the Contentful fallback itself; V1 (true) waits for a producer narrative
 * and offers a reveal button. Flip when Data Science and Logic Builder start emitting.
 *
 * Not a feature flag: `Sales-isLongFormAiEnabled` is already a per-`employeeId` allowlist, so exposure
 * is gated. Shipping V1 switched off decouples "merged" from "on" — merging it live would open every
 * enabled expert into a pending state nothing resolves. While false the reveal button and the
 * `trigger: "expert"` FallbackShown variant are unreachable.
 */
export const WAIT_FOR_PRODUCER_NARRATIVE = false;
